/**
 * Breadcrumb
 * Horizontal navigation breadcrumb with separator and current-page styling.
 */

import styled from '@emotion/styled';

export const Breadcrumb = styled.nav`
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  color: ${({ theme }) => theme.colors.text.secondary};
  padding: ${({ theme }) => theme.space.sm} 0 ${({ theme }) => theme.space.xs};

  a {
    color: ${({ theme }) => theme.colors.text.primary};
    text-decoration: none;
    font-weight: ${({ theme }) => theme.typography.config.weight.regular};

    &:hover {
      text-decoration: underline;
    }
  }

  span.separator {
    margin: 0 ${({ theme }) => theme.space.sm};
    color: ${({ theme }) => theme.colors.shades[300].color};
  }

  span.current {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;
